import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-diagnostic-thankyou',
  templateUrl: './diagnostic-thankyou.component.html',
  styleUrls: ['./diagnostic-thankyou.component.css']
})
export class DiagnosticThankyouComponent implements OnInit {
  tenant:any;
  date = '2022-08-05 06:00 PM';
  public PaymentstatusUtility: any = {
    completedDetails: {},
    isultimatePackage: true,
    nextEmiOption: {}
  }
  constructor(public router: Router) { 
    this.PaymentstatusUtility.completedDetails = this.router.getCurrentNavigation()?.extras;
    console.log(this.PaymentstatusUtility.completedDetails)
  }

  ngOnInit(): void {

  }

  login(){
    window.open('https://test.infinitylearn.com/signin','_self')
  }

}
